import { patientDeleteTask } from 'src/redux/actions/constant';

const {
  DELETE_PATIENT_TASK_FAILURE,
  DELETE_PATIENT_TASK_LOADER,
  DELETE_PATIENT_TASK_SUCCESS,
  RESET_DELETE_PATIENT_TASK,
} = patientDeleteTask;
const intialState: object = {
  response: null,
  loading: false,
  isTaskDelete: false,
};

export const deleteTaskPatientReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case DELETE_PATIENT_TASK_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isTaskDelete: true,
      };
    }
    case DELETE_PATIENT_TASK_FAILURE: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isTaskDelete: false,
      };
    }
    case DELETE_PATIENT_TASK_LOADER:
      return {
        ...state,
        loading: true,
      };

    case RESET_DELETE_PATIENT_TASK:
      return intialState;

    default:
      return state;
  }
};
